import React from 'react'
import '../App.css'
import Bodylogin from './login/bodylogin.js'
export class Bodyapploginbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className=''>
                    <Bodylogin
                        setStateApiKeyP={this.props.setStateApiKeyP} 
                        setStateMailP={this.props.setStateMailP}
                        setStateAuthCodeP={this.props.setStateAuthCodeP}/>
            </div>
        );
    }
}